module.exports = __webpack_public_path__ + "static/media/Page-1.03d073ff.jpg";